import { CarrierManagement } from "@/components/CarrierManagement";
import { useOrganization } from "@/hooks/useOrganization";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Carriers() {
  const { currentOrganization } = useOrganization();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const companyName = currentOrganization?.organization_name || "Your Company";
  const targetDashboard = (currentOrganization?.organization_type === 'customer') ? '/customer-dashboard' : '/carrier-dashboard';

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4 p-4">
        <Button variant="outline" onClick={() => navigate(targetDashboard)}>
          {t('dashboard.backToDashboard')}
        </Button>
      </div>
      <CarrierManagement companyName={companyName} />
    </div>
  );
}
